export const BRAND_NAME = "HEROw Company"
export const BRAND_DOMAIN = "herowcode.com"
export const BRAND_APP_URL = `https://app.${BRAND_DOMAIN}`
export const BRAND_TAGLINE = "Faça a gestão da sua empresa com eficiência."
